import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { IMAGES, LINKS } from "@/data/content";

export default function About() {
  return (
    <section id="sobre" data-testid="about-section" className="bg-white text-[#0F172A] py-24 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="relative">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:mx-0">
            <img
              src={IMAGES.about}
              alt="Retrato de João Garcez, travel designer"
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 rounded-3xl ring-1 ring-inset ring-[#0B1120]/10" />
          </div>
          <div className="absolute -bottom-6 -right-2 sm:right-6 lg:-right-6 bg-[#0B1120] text-white rounded-2xl px-7 py-6 shadow-2xl rotate-2">
            <span className="block font-display font-extrabold text-5xl leading-none text-[#00E5A3]">9</span>
            <span className="block mt-2 font-mono text-[10px] tracking-[0.25em] text-white/70 max-w-[140px]">
              ANOS DE EXPERIÊNCIA COM VIAGENS
            </span>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="font-mono text-[11px] sm:text-xs tracking-[0.35em] text-[#0055FE] mb-5">SOBRE JOÃO GARCEZ</p>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl">
              Uma história com o turismo que{" "}
              <em className="font-serif italic font-medium text-[#FF5A36]">começou cedo.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
              Comecei no turismo aos 13 anos. Hoje, aos 22, são 9 anos de experiência criando roteiros e planejando
              viagens.
            </p>
            <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
              Cada viajante tem um perfil, um sonho e um investimento. Meu trabalho é entender o que você procura e
              encontrar destinos, experiências e valores que combinem com você.
            </p>
          </Reveal>
          <Reveal delay={0.2} className="mt-8 flex flex-wrap items-center gap-6">
            <a
              href={LINKS.cotacao}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-cta-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#0055FE] text-white font-semibold px-7 py-3.5 hover:bg-[#0B1120] transition-colors duration-300"
            >
              Quero planejar minha viagem
              <ArrowUpRight size={18} />
            </a>
            <div className="leading-tight">
              <span className="block font-serif italic text-2xl text-[#0B1120]">João Garcez</span>
              <span className="block font-mono text-[10px] tracking-[0.25em] text-slate-500 mt-1">
                VIAGENS PENSADAS PARA VOCÊ.
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
